module.exports = __webpack_public_path__ + "media/images/partner/techinasia-1edc904cfe7c965859a475f15430145b.svg";